module.exports = __webpack_public_path__ + "static/media/enterprise_plus_banner_logo.0955dd5a.svg";